
import { defineComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';

import { epicContentComposition, epicDataComposition } from '../services';

import SidebarTimeline from './sidebar/sidebar-timeline.vue';

// Frames
import EpicStudyDesignFrame from './frames/epic-study-design-frame.vue';
import EpicStudyEndpointsFrame from './frames/epic-study-endpoints-frame.vue';
import EpicSelectedInclusionFrame from './frames/epic-selected-inclusion-criteria-frame.vue';
import EpicSelectedExclusionFrame from './frames/epic-selected-exclusion-criteria-frame.vue';
import EpicStatisticalMethodsFrame from './frames/epic-statistical-methods-frame.vue';
import EpicPrimaryEndpointFrame from './frames/epic-primary-endpoint-frame.vue';
import EpicPrimaryEndpointOverTimeFrame from './frames/epic-primary-endpoint-over-time-frame.vue';
import EpicSecondaryEndpointFrame from './frames/epic-secondary-endpoint-frame.vue';
import EpicSafetyOutcomesFrame from './frames/epic-safety-outcomes-frame.vue';
import EpicCommonAesFrame from './frames/epic-common-aes-frame.vue';

export default defineComponent({
    components: {
        SidebarTimeline,
        EpicStudyDesignFrame,
        EpicStudyEndpointsFrame
    },
    setup() {
        const store = useStore();

        const componentMap = ref<any>({
            'epic-study-design': EpicStudyDesignFrame,
            'epic-study-endpoints': EpicStudyEndpointsFrame,
            'epic-selected-inclusion-criteria': EpicSelectedInclusionFrame,
            'epic-selected-inclusion-criteria-extra': EpicSelectedInclusionFrame,
            'epic-selected-exclusion-criteria': EpicSelectedExclusionFrame,
            'epic-statistical-methods': EpicStatisticalMethodsFrame,
            'epic-primary-endpoint': EpicPrimaryEndpointFrame,
            'epic-primary-endpoint-over-time': EpicPrimaryEndpointOverTimeFrame,
            'epic-secondary-endpoint': EpicSecondaryEndpointFrame,
            'epic-safety-outcomes': EpicSafetyOutcomesFrame,
            'epic-common-aes': EpicCommonAesFrame
        });

        // Computed active section
        const activeSection = computed((): string => store.getters.get_ehrActiveSection);
        const activeFrame = computed((): string => store.getters.get_ehrActiveFrame);
        const activeComponent = computed((): any => (componentMap.value[activeFrame.value] || null));

        return { ...epicDataComposition(), ...epicContentComposition(), activeComponent, activeSection, activeFrame };
    }
})
